import { render } from "./Coaches.vue?vue&type=template&id=028b7cc2&scoped=true&ts=true"
import script from "./Coaches.vue?vue&type=script&lang=ts"
export * from "./Coaches.vue?vue&type=script&lang=ts"

import "./Coaches.vue?vue&type=style&index=0&id=028b7cc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028b7cc2"]])

export default __exports__